import React, { useEffect, useState } from "react";
import {Col} from "react-bootstrap";

const AnimatedCounter = ({ value = 0, text= "", sign = "", duration = 2000 }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        const start = performance.now();

        const animate = (time) => {
            const progress = Math.min((time - start) / duration, 1);
            const current = Math.floor(progress * value);
            setCount(current);

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        };

        requestAnimationFrame(animate);
    }, [value, duration]);

    return (
        <Col sm={12} md={12} lg={4} className="key">
            <div className="key-content">
                <span className="key-numbers">{sign}{count.toLocaleString()}</span>
                <span className="key-title" dangerouslySetInnerHTML={{ __html: text }}></span>
            </div>
        </Col>
    );
};

export default AnimatedCounter;
